import Reveal from "@/components/base/Reveal";

const themes = [
  {
    icon: "ri-home-heart-line",
    title: "家庭亲情",
    en: "Family",
    desc: "镜头对准亲子、兄弟姐妹与照护关系，冲突往往来自责任如何分配、旧账如何清算。",
    points: ["离婚与抚养", "亲子沟通", "老年照护"],
  },
  {
    icon: "ri-heart-3-line",
    title: "婚姻情感",
    en: "Marriage",
    desc: "围绕两个人的相处方式展开，重点不是外遇或意外，而是沟通怎样一点点失效。",
    points: ["相处与倦怠", "分开与协商", "亲密与孤独"],
  },
  {
    icon: "ri-global-line",
    title: "社会议题",
    en: "Society",
    desc: "从个人处境切入更大的问题，讨论偏见、责任与舆论如何影响普通人的决定。",
    points: ["偏见与误解", "媒体与责任", "正义与谅解"],
  },
  {
    icon: "ri-seedling-line",
    title: "成长与自我",
    en: "Coming of Age",
    desc: "关注一个人如何被环境、时间与选择塑造，常带有自我认同与和解的主题。",
    points: ["身份认同", "时间跨度", "隐忍与表达"],
  },
];

export default function GenreSection() {
  return (
    <section id="genres" className="py-16 md:py-24 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <Reveal>
          <div className="max-w-3xl">
            <span className="text-xs md:text-sm font-label tracking-widest text-primary-600 uppercase">What It Covers</span>
            <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950">先弄清楚：这类电影在讲什么</h2>
            <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-600">
              欧美伦理电影并不是一个严格的电影类型，而是中文语境里对一类作品的统称——它们大多属于剧情片，
              把叙事重心放在人与人之间的关系、道德选择与后果上。判断一部片子是否属于这一类，可以看它是否把
              <strong className="font-medium text-foreground-900">“选择的代价”</strong>放在故事中心。
            </p>
          </div>
        </Reveal>

        <div className="mt-10 md:mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {themes.map((t, i) => (
            <Reveal key={t.title} delay={i * 80}>
              <article className="h-full rounded-lg border border-background-200 bg-background-100 p-5 flex flex-col">
                <div className="w-11 h-11 rounded-md bg-primary-100 text-primary-600 flex items-center justify-center">
                  <i className={`${t.icon} text-2xl`}></i>
                </div>
                <h3 className="mt-4 font-heading text-lg font-semibold text-foreground-950">{t.title}</h3>
                <p className="text-xs font-label tracking-wide text-secondary-600 uppercase mt-1">{t.en}</p>
                <p className="mt-3 text-sm leading-relaxed text-foreground-600 flex-1">{t.desc}</p>
                <ul className="mt-4 flex flex-wrap gap-2">
                  {t.points.map((p) => (
                    <li key={p} className="px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-900 text-xs">
                      {p}
                    </li>
                  ))}
                </ul>
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal>
          <div className="mt-10 rounded-lg bg-secondary-50 border border-secondary-200 p-5 md:p-7 flex flex-col md:flex-row gap-5 md:gap-8">
            <div className="flex items-start gap-3 md:w-1/3">
              <span className="w-10 h-10 rounded-md bg-secondary-500 text-background-50 flex items-center justify-center shrink-0">
                <i className="ri-lightbulb-line text-xl"></i>
              </span>
              <div>
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950">怎么判断是不是你想看的</h3>
                <p className="text-xs text-foreground-500 mt-1">三个快速判断点</p>
              </div>
            </div>
            <ol className="flex-1 grid grid-cols-1 sm:grid-cols-3 gap-4">
              <li className="text-sm leading-relaxed text-foreground-700">
                <span className="font-label text-secondary-600 font-semibold">01</span>
                <p className="mt-1">看它是否以对话和人物状态推动，而不是靠事件反转。</p>
              </li>
              <li className="text-sm leading-relaxed text-foreground-700">
                <span className="font-label text-secondary-600 font-semibold">02</span>
                <p className="mt-1">看结局是否留白，把判断交还给观众。</p>
              </li>
              <li className="text-sm leading-relaxed text-foreground-700">
                <span className="font-label text-secondary-600 font-semibold">03</span>
                <p className="mt-1">看它讨论的是关系还是立场，前者更贴近伦理题材。</p>
              </li>
            </ol>
          </div>
        </Reveal>
      </div>
    </section>
  );
}